import { Api, DataResponse } from "imagine-essentials";
import {
  Address,
  Defect,
  DefectStatus,
  DefectStatusEntry,
  DefectsFilter,
  DeleteStatus,
  Image,
} from "..";
import i18next from "i18next";

const getAddress = async (addressCode: string) => {
  const result = await Api.get("api/defects/address/" + addressCode);
  const response: DataResponse<Address> = {
    success: result.success,
  };
  if (result.success && result.data) {
    response.data = result.data;
  }
  return response;
};

const getDefect = async (id: number) => {
  const result = await Api.get("api/defects/" + id);
  const response: DataResponse<Defect> = {
    success: result.success,
  };
  if (result.success && result.data) {
    response.data = result.data;
  }
  return response;
};

const getDefects = async (filter: DefectsFilter) => {
  const result = await Api.get("api/defects", filter);
  const response: DataResponse<Defect[]> = {
    success: result.success,
  };
  if (result.success && result.data) {
    response.data = result.data;
  }
  return response;
};

const getAddressDefects = async (addressCode: string) => {
  const result = await Api.get("api/defects/address/" + addressCode);
  const response: DataResponse<Defect[]> = {
    success: result.success,
  };
  if (result.success && result.data) {
    response.data = result.data;
  }
  return response;
};

const createDefect = async (addressCode: string, defect: Defect) => {
  const result = await Api.post(
    "api/defects/address/" + addressCode + "/add",
    defect
  );
  const response: DataResponse<Defect> = {
    success: result.success,
  };
  if (result.success && result.data) {
    response.data = result.data;
  }
  return response;
};

// const createDefect = async (defect: Defect) => {
//   const result = await Api.post("api/defects/add", defect);
//   const response: DataResponse<Defect> = {
//     success: result.success,
//   };
//   if (result.success && result.data) {
//     response.data = result.data;
//   }
//   return response;
// };

const updateDefect = async (addressCode: string, defect: Defect) => {
  const result = await Api.post(
    "api/defects/address/" + addressCode + "/update/" + defect.id,
    defect
  );
  const response: DataResponse<Defect> = {
    success: result.success,
  };
  if (result.success && result.data) {
    response.data = result.data;
  }
  return response;
};

const updateStatus = async (
  addressCode: string,
  defectId: number,
  status: DefectStatusEntry
) => {
  const result = await Api.post(
    "api/defects/address/" + addressCode + "/status/" + defectId,
    status
  );
  console.log("Update status result", result);
  const response: DataResponse<void> = {
    success: result.success,
  };
  if (result.status === 207) {
    response.errorMessage = i18next.t("punchlist:emailNotSentToResident");
  }
  if (result.success && result.data) {
    response.data = result.data;
  }
  return response;
};

// const updateDefect = async (defect: Defect) => {
//   const result = await Api.post("api/defects/update/" + defect.id, defect);
//   const response: DataResponse<Defect> = {
//     success: result.success,
//   };
//   if (result.success && result.data) {
//     response.data = result.data;
//   }
//   return response;
// };

const uploadImages = async (defectId: number, images: File[]) => {
  const formData = new FormData();
  formData.append("imageCount", images.length.toString());
  for (let i = 0; i < images.length; i++) {
    formData.append("image" + i, images[i]);
  }
  const result = await Api.postForm("api/defects/images/" + defectId, formData);
  const response: DataResponse<void> = { success: result.success };
  if (result.success && result.data) {
    if (result.data.errors) {
      response.errorMessage = i18next.t("punchlist:imageUploadFailedCount", {
        count: result.data.errors,
      });
    }
  } else {
  }
  return response;
};

const removeImage = async (imageId: number) => {
  const result = await Api.post("api/defects/images/remove/" + imageId, {});
  const response: DataResponse<void> = { success: result.success };
  if (result.success) {
    response.data = result.data;
  }
  return response;
};

const deleteDefect = async (defectId: number) => {
  const result = await Api.post("api/defects/delete/" + defectId, {});
  const response: DataResponse<DeleteStatus> = { success: result.success };
  if (result.success && result.data) {
    response.data = result.data;
  }
  return response;
};

export const DefectsApi = {
  getAddress,
  getDefect,
  getDefects,
  getAddressDefects,
  createDefect,
  updateDefect,
  updateStatus,
  uploadImages,
  removeImage,
  deleteDefect,
};
